<script>

    import BlockEditor from "../../../../../../../js/common/canvas/editor/canvas/document/editors/BlockEditor";

    export default {

        extends: BlockEditor,

        appearance: function()
        {
            return {
                icon: 'fa fa-fw fa-image',
                name: 'Afbeelding',
            };
        },

        computed: {

            // Not reactive.
            hasMedia()
            {
                // @ugly Add data-media to element instead?
                return this.element.is('[srcset]');
            },

        },

    }

</script>

<style lang="scss">

    .galaxy\:\:common-canvas-blocks-utils-image-Block {

        &[data-canvas-editable] {
            user-select: none;
        }

    }

</style>